import { render, staticRenderFns } from "./Theme.vue?vue&type=template&id=547f2f7f"
import script from "./Theme.vue?vue&type=script&lang=js"
export * from "./Theme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('547f2f7f')) {
      api.createRecord('547f2f7f', component.options)
    } else {
      api.reload('547f2f7f', component.options)
    }
    module.hot.accept("./Theme.vue?vue&type=template&id=547f2f7f", function () {
      api.rerender('547f2f7f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Theme.vue"
export default component.exports